import React from 'react';
import './LoadingSpinner.css';

/**
 * LoadingSpinner Component - Displays a loading state with optional message
 *
 * @param {Object} props
 * @param {string} [props.message="Loading..."] - Message to display below spinner
 * @param {string} [props.className=""] - Additional CSS classes
 */
function LoadingSpinner({ message = "Loading...", className = "" }) {
  return (
    <div className={`loading-container ${className}`}>
      <div className="loading-spinner"></div>
      <p>{message}</p>
    </div>
  );
}

export default LoadingSpinner;
